import { css, Interpolation, Theme } from '@emotion/react'

export const title: Interpolation<Theme> = (theme: Theme) => css`
  font-size: 16px;
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 10px;
`

export const emptyBlock: Interpolation<Theme> = (theme: Theme) => css`
  height: 80px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.typographyColors.typographyFour};
  background-color: ${theme.backgrounds.backgroundThree};
  border-radius: 20px;
`

export const table: Interpolation<Theme> = (theme: Theme) => css`
  padding: 16px;
  background-color: ${theme.backgrounds.backgroundThree};
  border-radius: 20px;

  .table-row {
    padding: 5px 12px;
  }
`

export const errorCell: Interpolation<Theme> = (theme: Theme) => css`
  color: ${theme.colors.red};
`
